// 純資料格式化工具：相對時間、問題類型對應

export function getDiff(date) {
  const timestamp = new Date(date).getTime() / 1000;
  let mistiming = Math.round(new Date() / 1000) - timestamp;
  const postfix = mistiming > 0 ? '前' : '後';
  mistiming = Math.abs(mistiming);
  const timeArray = ['年', '個月', '星期', '天', '小時', '分鐘', '秒'];
  const timeSec = [31536000, 2592000, 604800, 86400, 3600, 60, 1];

  for (let i = 0; i < 7; i += 1) {
    const inm = Math.floor(mistiming / timeSec[i]);
    if (inm !== 0) {
      return `${inm} ${timeArray[i]}${postfix}`;
    }
  }
  return 'error';
}

export function questionType(type) {
  if (type === 'question') {
    return '課程問題';
  }
  if (type === 'homework') {
    return '作業繳交';
  }
  return '';
}

export function transformTypeToId(type) {
  if (type === 'question') {
    return 1;
  }
  if (type === 'homework') {
    return 2;
  }
  return '';
}
